import Controller from '@ember/controller';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';

import { Spinner } from '@repo/design-system-kit';

import styles from './styles.module.css';
export default class RegistrationPricePlanLoadingController extends Controller {
  spinner = Spinner;

  queryParams = ['period'];

  @tracked period = 'yearly';

  @action
  selectPeriod(period) {
    this.period = period;
  }
  styles = styles;
}
